export default "__VITE_ASSET__CgYOnDwO__"